import { InvitationStatus } from '@weenat/client/dist/enums'
import { Invitation } from '@weenat/client/dist/resources/invitations'
import { RequestType } from '@weenat/client/dist/resources/types'
import { WeenatColor } from '@weenat/theme'
import { useIntl } from '@weenat/wintl'
import isNil from 'lodash-es/isNil'
import { memo } from 'react'
import AdminBadge from './AdminBadge'
import TrialBadge from './TrialBadge'

type Qualifier = keyof typeof InvitationStatus

interface StatusBadgeProps {
  invitation: Invitation
}

const StatusBadge: FC<StatusBadgeProps> = ({ invitation }) => {
  const { t } = useIntl()
  const { status, type } = invitation

  const isTrial =
    type === RequestType.adherentFarmRequestWithTrial ||
    type === RequestType.adherentFarmInvitationWithTrial

  let qualifier: Qualifier | null = null
  let backgroundColor: WeenatColor = 'primary.500'
  let labelColor: WeenatColor = 'grayscale.white'

  switch (status) {
    case InvitationStatus.accepted:
      qualifier = 'accepted'
      backgroundColor = 'feedback.success.500'
      labelColor = 'grayscale.black'
      break

    case InvitationStatus.declined:
      qualifier = 'declined'
      backgroundColor = 'feedback.error.500'
      labelColor = 'grayscale.black'
      break

    case InvitationStatus.pending:
      qualifier = 'pending'
      break

    case InvitationStatus.duplicated:
      qualifier = 'duplicated'
      backgroundColor = 'grayscale.500'
      break

    case InvitationStatus.invalid:
      qualifier = 'invalid'
      backgroundColor = 'feedback.warn.500'
      labelColor = 'grayscale.black'
      break

    case InvitationStatus.cancel:
      qualifier = 'cancel'
      backgroundColor = 'feedback.error.500'
      labelColor = 'grayscale.black'
      break
  }

  const message = !isNil(qualifier)
    ? t(`qualifiers_feminine.${qualifier}`, { capitalize: true })
    : null

  const statusBadge = !isNil(message) ? (
    <AdminBadge $backgroundColor={backgroundColor} labelColor={labelColor} label={message} />
  ) : null

  return !isNil(message) ? (
    <>
      {isTrial ? (
        <Flex $alignItems='center' $gap='md'>
          {statusBadge}
          <TrialBadge />
        </Flex>
      ) : (
        statusBadge
      )}
    </>
  ) : null
}

export default memo(StatusBadge)
